import React from 'react'
import styles from './index.module.less'
import {Tag} from '@/arco'
import language from '@/utils/language'
export default  function CreateHeader(props) {
    return <div className={styles.showDialogHerader}>{props.title}{props.icon || ""}{props.item ? (props.item.status == 0 ? <Tag type="error" children={language('market11')} /> : <Tag type="blue" children={language('market10')} />) : ""}</div>
}
